document.addEventListener('DOMContentLoaded', function() {
  
  var forms = document.querySelectorAll('.mara-add-form');
  
  forms.forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      
      var button = form.querySelector('.mara-add-btn');
      var formData = new FormData(form);
      
      button.classList.add('loading');
      
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(function(response) {
        return response.json();
      })
      .then(function(data) {
        button.classList.remove('loading');
        button.classList.add('success');
        
        // Mostrar notificación flotante
        showCartNotification();
        
        // Actualizar contador del carrito si existe
        updateCartCount();
        
        // Restablecer botón después de 2 segundos
        setTimeout(function() {
          button.classList.remove('success');
        }, 2000);
      })
      .catch(function(error) {
        console.error('Error:', error);
        button.classList.remove('loading');
        alert('Hubo un error al agregar el producto. Intenta nuevamente.');
      });
    });
  });
  
  // Notificación flotante
  function showCartNotification() {
    var existingNotify = document.querySelector('.mara-cart-notify');
    if (existingNotify) {
      existingNotify.remove();
    }
    
    var notify = document.createElement('div');
    notify.className = 'mara-cart-notify';
    notify.innerHTML = '<span>✦</span> Producto añadido al carrito';
    document.body.appendChild(notify);
    
    setTimeout(function() {
      notify.classList.add('show');
    }, 100);
    
    setTimeout(function() {
      notify.classList.remove('show');
      setTimeout(function() {
        notify.remove();
      }, 400);
    }, 3000);
  }
  
  // Actualizar contador del carrito
  function updateCartCount() {
    fetch('/cart.js')
      .then(function(response) {
        return response.json();
      })
      .then(function(cart) {
        // Buscar elementos comunes del contador del carrito
        var counters = document.querySelectorAll('.cart-count, .cart-count-bubble, [data-cart-count], .cart__count');
        counters.forEach(function(counter) {
          counter.textContent = cart.item_count;
          if (cart.item_count > 0) {
            counter.style.display = '';
          }
        });
      });
  }
});